import { Checkbox } from '@infotech-soe/erp-ui-kit';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { DatasetColumnFormat } from '../../../../../services/dataset/view-model/DatasetGridColumn';

import DateConditions from './DateConditions';
import EnumConditions from './EnumConditions';
import { messages } from './messages';
import NumberConditions from './NumberConditions';
import TextConditions from './TextConditions';
import {
  InputConditionsProps,
  InputName,
  InternalTypes,
  ValueTypes,
} from './types';

const CONDITION_COMPONENT_MAP = {
  [InternalTypes.ENUM]: EnumConditions,
  [DatasetColumnFormat.STRING]: TextConditions,
  [DatasetColumnFormat.DATE]: DateConditions,
  [DatasetColumnFormat.DATE_TIME_SEC]: DateConditions,
  [DatasetColumnFormat.NUMBER]: NumberConditions,
} as const;

const isSupportedConditionComponentType = (
  key: number | string
): key is keyof typeof CONDITION_COMPONENT_MAP =>
  key in CONDITION_COMPONENT_MAP;

const InputConditions = (
  props: InputConditionsProps<ValueTypes>
): React.JSX.Element => {
  const { column, condition, onChange } = props;
  const { formatMessage } = useIntl();
  const type = column.domain.values ? InternalTypes.ENUM : column.format;

  const Component =
    isSupportedConditionComponentType(type) && CONDITION_COMPONENT_MAP[type];

  return (
    <>
      <Checkbox
        className="m-mb-md items-stretch self-start"
        label={formatMessage(messages.applyToRow)}
        name={InputName.ISAPPLYRULETOROW}
        value={condition.value?.isApplyRuleToRow}
        onChange={onChange}
      />
      {Component && <Component {...props} />}
    </>
  );
};

export default memo(InputConditions);
